import { render, staticRenderFns } from "./ForgetPasswdPopWindow.vue?vue&type=template&id=98161ae6&scoped=true&"
import script from "./ForgetPasswdPopWindow.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswdPopWindow.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswdPopWindow.vue?vue&type=style&index=0&id=98161ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98161ae6",
  null
  
)

export default component.exports